import { render, staticRenderFns } from "./ProducedPanel.vue?vue&type=template&id=41f38b10&"
import script from "./ProducedPanel.vue?vue&type=script&lang=js&"
export * from "./ProducedPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports